module.exports = __webpack_public_path__ + "img/product1_l.1500a630.jpg";